var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-one-forth has-borders-column"},[_c('span',{staticClass:"heading-inline"},[_vm._v("ocena")]),_c('br'),_c('small',[_c('progress',{staticClass:"progress",class:{
            'is-danger': _vm.broker.rate < 2,
            'is-warning': _vm.broker.rate < 4 && _vm.broker.rate >= 2,
            'is-success': _vm.broker.rate >= 4,
        },attrs:{"max":"5"},domProps:{"value":_vm.broker.rate}}),_vm._v(" "+_vm._s(_vm.broker.rate.toFixed(1))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }